<div class="container">
    <!-- Mobile header -->
    <header class="header" fxShow fxHide.gt-xs>
        <div class="header-title">
            <h1 class="title">{{"Goals" | translate}}</h1>
            <div class="header-stats">
                <div class="header-goals-in-progress">
                    <p class="header-goal-counter">{{ goalsInProgress }}</p>
                    <p class="header-goal-subtitle">{{ "Goals in progress" | translate }}</p>
                </div>
                <div class="header-goals-at-risk">
                    <p class="header-goal-counter">{{ goalsAtRisk }}</p>
                    <p class="header-goal-subtitle">{{ "Goals at risk" | translate }}</p>
                </div>
            </div>
        </div>
        
        <button mat-flat-button color="primary" class="goal-btn" (click)="onCreateGoal()">{{"New Goal" | translate}}</button>
    </header>
<!-- End of mobile header -->

    <header class="header" fxHide fxShow.gt-xs>
        <div class="header-title">
            <h1 class="title">{{"Goals" | translate}}</h1>
            <p>{{ "Create SMART goals for yourself to stay on track for success" | translate}}</p>
            <button mat-flat-button color="primary" class="goal-btn" (click)="onCreateGoal()">{{"New Goal" | translate}}</button>
        </div>
        <div class="header-stats">
            <div class="header-goals-in-progress">
                <p class="header-goal-counter">{{ goalsInProgress }}</p>
                <p class="header-goal-subtitle">{{ "Goals in progress" | translate }}</p>
            </div>
            <div class="header-goals-at-risk">
                <p class="header-goal-counter">{{ goalsAtRisk }}</p>
                <p class="header-goal-subtitle">{{ "Goals at risk" | translate }}</p>
            </div>
        </div>
    </header>

    
    <mat-divider class="divider"></mat-divider>
    
    <main>
        <app-goals-headerbar fxHide fxShow.gt-xs></app-goals-headerbar>
        
        <app-goals-item 
            *ngFor="let goal of allStudentGoalsData" 
            [goalsData]="goal"
            (refreshDataEvent)="refreshData($event)"
        >
        </app-goals-item>
    </main>
    
</div>
